/** Pure logic of the workshop dialog (port of the AddWorkshopComponent form). */
import { EMAIL_PATTERN } from '@/shared/lib/validation';
import type { WorkshopInput, WorkshopRecord } from './api';

/** The form edits exactly the fields sent to the API. */
export type WorkshopFormValues = WorkshopInput;

export type WorkshopFormErrors = Partial<
  Record<keyof WorkshopFormValues, string>
>;

// The historical pattern was given as a string ('...[-\s\./0-9]*$'), where `\s`
// and `\.` lose their backslash: the class really is `[-s./0-9]`. Kept as-is
// (see migration.md, Product Owner review).
const PHONE_PATTERN = /^\+*\(?\d{1,4}\)?[-s./\d]*$/;

export const emptyWorkshopForm = (): WorkshopFormValues => ({
  name: '',
  fullAddress: '',
  email: '',
  phone: '',
});

export const workshopToForm = (
  workshop: WorkshopRecord,
): WorkshopFormValues => ({
  name: workshop.name ?? '',
  fullAddress: workshop.fullAddress ?? '',
  email: workshop.email ?? '',
  phone: workshop.phone ?? '',
});

export const validateWorkshopForm = (
  values: WorkshopFormValues,
): WorkshopFormErrors => {
  const errors: WorkshopFormErrors = {};
  if (!values.name || values.name.length > 100) errors.name = 'Wrong name';
  if (!values.fullAddress || values.fullAddress.length > 500)
    errors.fullAddress = 'Wrong address';
  if (
    !values.email ||
    values.email.length > 50 ||
    !EMAIL_PATTERN.test(values.email)
  )
    errors.email = 'Wrong email';
  if (
    values.phone &&
    (values.phone.length > 20 || !PHONE_PATTERN.test(values.phone))
  )
    errors.phone = 'Wrong phone';
  return errors;
};
